
export default class StringUtil {

    static camelToSnake(str: string) {
        return str
            .replace(/([a-z0-9])([A-Z])/g, "$1_$2") // 在小写+大写之间加下划线
            .toLowerCase();
    }

}
